// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"344":"164cb7e1","620":"fc6ba77c","924":"3ba5694e"}[chunkId] + ".js";
};